export default {
  // 页面标题
  title: '账单与支付',
  
  // 账单信息部分
  billingInformation: {
    title: '账单信息',
    edit: '编辑',
    save: '保存',
    email: {
      label: '账单邮箱：',
      placeholder: '账单更新将发送至该邮箱'
    },
    companyProfile: {
      label: '公司发票资料：',
      placeholder: '将在发票上展示的补充信息，如地址、采购单号等'
    }
  },
  
  // 支付方式部分
  paymentMethod: {
    setup: {
      title: '设置支付方式',
      button: '去设置',
      updateButton: '更新'
    },
    availableFunds: {
      title: '可用余额',
      currency: 'USD',
      description: '支持主流信用卡与借记卡。若需银行转账等其他方式，请联系',
      supportEmail: 'support@aha.inc',
      depositButton: '充值'
    },
    freeCredits: {
      title: '免费额度',
      currency: 'USD',
      description: '确认达人后将自动抵扣，最高可覆盖达人付款的 10%。'
    },
    card: '银行卡'
  },
  
  // 账单历史部分
  billingHistory: {
    billingTitle: '账单记录',
    depositTitle: '充值记录',
    downloadButton: '下载明细',
    influencerNamePlaceholder: '达人姓名',
    table: {
      date: '日期',
      totalAmount: '总金额',
      bonus: '佣金',
      totalCredited: '总充值',
      orderId: '订单号',
      campaignName: '活动名称',
      influencerName: '达人姓名',
      paymentStatus: '支付状态',
      status: '状态'
    },
    pagination: {
      previous: '上一页',
      next: '下一页'
    }
  },
  
  // 支付状态
  paymentStatus: {
    paid: '已向达人付款',
    refunded: '已退款',
    onHold: '托管中',
    default: '-'
  },
  
  // 消息提示
  messages: {
    emailRequired: '请输入邮箱地址。',
    nameRequired: '请输入名称。',
    saveSuccess: '保存成功！',
    downloadError: '下载失败：{error}'
  },
  
  // 模态框
  modal: {
    companyProfile: {
      title: '公司开票资料',
      submit: '提交'
    }
  }
};
